import { useCallback, useState } from 'react'

const useCheckoutValidation = (errors = {}) => {
    const [submitAttempted, setSubmitAttempted] = useState(false)

    const isValid = !Object.keys(errors).some(field => !!errors[field])

    // Called when the customer clicks Buy. Returns whether the purchase may go through.
    const validate = useCallback(() => {
        setSubmitAttempted(true)

        return isValid
    }, [isValid])

    return {
        errors: submitAttempted ? errors : {},
        isValid,
        validate,
        submitAttempted,
    }
}

export default useCheckoutValidation
